module.exports = __webpack_public_path__ + "static/media/more.3e31f542.svg";